import type { AssignmentFormData } from '../../../types/assignmentTypes';
import ContentFormPreview from '../ContentFormPreview';
import { useFormContext } from 'react-hook-form';
import { useParams } from 'react-router-dom';

export default function ContentFormPreviewWrapper() {
  const { id } = useParams();
  const { watch } = useFormContext<AssignmentFormData>();

  const { settings, simpleType } = watch();

  return (
    <ContentFormPreview
      settings={settings}
      isLocked={!!id && simpleType === 'pointInTime'}
      renderStatus
    />
  );
}
